module.exports = __webpack_public_path__ + "front/img/p21.124bce4a.png";